export default __webpack_public_path__ + "static/media/IconDesc_LiquidBiofuel.256.85cab4c9.png";